import React from 'react'
import "bootstrap-icons/font/bootstrap-icons.css";

import SimpleProcess from './SimpleProcess'
import EligibilitySlider from './EligibilitySlider'
import LoanCalculator from './LoanCalculator'

const whyChoose = [
  { icon: "bi-percent", text: "Attractive Interest Rates" },
  { icon: "bi-lightning-charge", text: "Instant Loan Approval" },
  { icon: "bi-file-earmark-check", text: "Minimal Documentation Required" },
  { icon: "bi-shield-lock", text: "Safe & Secure Gold Storage" },
  { icon: "bi-cash-stack", text: "High Loan-to-Value (LTV) Ratio" },
  { icon: "bi-headset", text: "Dedicated Customer Support" },
];

const loanFeatures = [
  { icon: "bi-currency-rupee", text: "Loan Amount: Based on gold purity & weight" },
  { icon: "bi-clock-history", text: "Flexible Tenure: Up to 12 months" },
  { icon: "bi-lightning", text: "Instant Disbursal" },
  { icon: "bi-arrow-repeat", text: "Easy Renewal & Part-Payment Options" },
  { icon: "bi-shield-check", text: "Transparent Valuation & Processing" },
];

const GoldLoan = () => {
  return (
    <div>

      {/* Hero Section */}
      <section className="welcome_area gold" id="home">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">

                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge">Gold Loan</p>
                    </div>
                    <span className="integration-text">
                      Unlock the Value of Your Gold Instantly
                    </span>
                  </div>
                </div>

                <h1 className="b-text bold">
                  Quick & Secure Gold Loans with Me Loans
                </h1>

                <p>
                  Get instant funds by pledging your gold jewelry with Me Loans. 
                  Enjoy competitive interest rates, safe storage, and quick 
                  disbursal with minimal paperwork.
                </p>

                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="/contact" className="btn more-btn mr-3">
                    Contact Us
                  </a>
                  <a className="btn more-btn" href="/apply-for-loan">
                    Apply For Loan
                  </a>
                </div>

              </div>
            </div>

            <div className="col-lg-6"></div>

          </div>
        </div>
      </section>


      {/* About Section */}
      <section className="about-us-area section-padding-100 clearfix">
        <div className="container-fluid">
          <div className="row align-items-center">

            <div className="col-12 col-lg-6 offset-lg-0 col-md-12 no-padding-left">
              <div className="welcome-meter fadeInUp" data-wow-delay="0.7s">
                <img draggable="false" src="image/gold.png" alt="Gold Loan" />
              </div>
            </div>

            <div className="col-12 col-lg-6 offset-lg-0 col-md-10 offset-md-1">
              <div className="who-we-contant mt-s">

                <h4 className="fadeInUp" data-wow-delay="0.3s">
                  Why Choose Me Loans for Your Gold Loan?
                </h4>

                <p className="fadeInUp" data-wow-delay="0.4s">
                  Me Loans offers fast and secure gold loans with transparent 
                  valuation and attractive interest rates. Your gold is stored 
                  safely in secure vaults while you receive immediate funds.
                </p>

                <p className="fadeInUp" data-wow-delay="0.5s">
                  With flexible repayment options and easy renewal facilities, 
                  our gold loans provide a convenient solution for your 
                  short-term financial needs.
                </p>

                <a
                  className="btn more-btn mt-30 fadeInUp"
                  data-wow-delay="0.6s"
                  href="/apply-for-loan"
                >
                  Apply For Loan
                </a>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Why Choose & Loan Features */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="text-center mb-5">
            <h2 className="fw-bold">
              Why Choose Me Loans for Gold Loan?
            </h2>
          </div>

          <div className="row g-4 mb-5">
            {whyChoose.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="feature-box shadow-sm p-4 bg-white rounded h-100 d-flex align-items-center">
                  <i className={`bi ${item.icon} feature-icon me-3`}></i>
                  <h6 className="mb-0">{item.text}</h6>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mb-4">
            <h3 className="fw-bold text-secondary">Loan Features</h3>
          </div>

          <div className="row g-4">
            {loanFeatures.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="feature-box shadow-sm p-4 bg-white rounded h-100 d-flex align-items-center">
                  <i className={`bi ${item.icon} feature-icon me-3`}></i>
                  <h6 className="mb-0">{item.text}</h6>
                </div>
              </div>
            ))}
          </div>

        </div>

        <style>{`
          .feature-box {
            transition: 0.3s ease;
          }

          .feature-box:hover {
            transform: translateY(-6px);
          }

          .col-md-6.col-lg-4 {
            padding: 6px;
          }

          .feature-icon {
            font-size: 28px;
            color: #1fa5a9;
          }
        `}</style>

      </section>

      <SimpleProcess />
      <LoanCalculator />
      <EligibilitySlider />

    </div>
  )
}

export default GoldLoan